export enum CancelType {
  None,
  ThisMonth,
  NextMonth,
}

export enum CanCancelSubscriptionTypes {
  Show,
  Disable,
  Hide,
}

export interface SubscriptionItemModel {
  orderProductId: number;
  productId: number;
  orderId: number;
  name: string;
  image: string;
  startYear: number;
  startMonth: number;
  endYear: number;
  endMonth: number;
  total: number;
  totalTaxes: number;
  isExpired: boolean;
  dateAdded?: Date;
  cancelType: CancelType;
  canCancelSubscription: CanCancelSubscriptionTypes;
  displayOneMonthExtra: boolean;
}
